
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import Navigation from "./Navigation";
import SessionExpired from "../../components/SessionExpired";
import config from "../../config";
import LoadingIcon from "../../../src/icons-svg/icon_loading.svg";

const MainLayout = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { i18n, t } = useTranslation();
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [docList, setDocList] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Menü yüklenirken true
  const [loading, setLoading] = useState(false);   // Modal kaydetme sonrası true
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const handleDocSelect = (doc) => setSelectedDoc(doc);

  const handleNavDataLoaded = (data) => {
    setDocList(data);
    setIsLoading(false);
    setLoading(false);
    setIsInitialLoad(false); // Menü yüklendiğinde artık ilk yükleme değil

    // İlk dokümanı otomatik seç
    if (data.length > 0) {
      const firstDoc = data.find((item) => item.uuid && !item.isHeader);
      if (firstDoc) setSelectedDoc(firstDoc);
    }
  };

  // Modal kaydetme sonrası çağrılacak 
  const handleProductVersionChange = () => {
    setSelectedDoc(null);
    setLoading(true);
    setIsInitialLoad(false); // Modal sonrası da artık ilk yükleme değil
  };


  if (!isLoggedIn) return <Navigate to="/authentication" replace />;

  return (
    <div className="flex flex-col h-screen bg-white overflow-hidden">
      <Header selectedDoc={selectedDoc} language={i18n.language} />

      <div className="flex flex-1 pt-14 overflow-hidden">
        <Navigation
          onDocSelect={handleDocSelect}
          onNavDataLoaded={handleNavDataLoaded}
          onProductVersionChange={handleProductVersionChange} // Modal sonrası
        />
        <main className="flex-1 relative">
          {selectedDoc ? (
            <iframe
              title={selectedDoc.title}
              src={`${config().HELP_URL}/displayDoc?docUuid=${selectedDoc.uuid}&language=${i18n.language}`}
              className="w-full h-full border-none"
            />
          ) : (isLoading || loading) ? (
            <div className="flex flex-col items-center justify-center h-full text-sm font-roboto px-4 text-center">
              <img src={LoadingIcon} className="w-8 h-8 mb-2" alt="Loading" />
              <span>{t("loadingData")}</span>
            </div>
          ) : (
            <div className="flex items-center justify-center h-full text-gray-500 text-sm">
             <div>{t("noDocumentSelected")}</div> 
            </div>
          )}
        </main>
      </div>
      <SessionExpired />
    </div>
  );
};

export default MainLayout;

























